import { HttpApi, HttpApiEndpoint, HttpApiGroup, OpenApi } from "@effect/platform";
import { InternalServerError } from "@effect/platform/HttpApiError";
import * as Keys from "./keys";
import { Schema } from "effect";
import { ApplicationId, StripeEnvironmentParam, StripeProductIdParam } from "./context";
import { StripeApiMiddleware, StripeControllerMiddleware } from "./middleware";
import { StripePrice } from "./price";
import { StripeProduct } from "./product";
export const StripeApi = HttpApiGroup.make("stripe").annotate(OpenApi.Description, "Stripe API").add(HttpApiEndpoint.get("products")`/applications/${ApplicationId}/stripe/${StripeEnvironmentParam}/products`.addSuccess(Schema.Struct({
    object: Schema.Literal("list"),
    data: Schema.Array(StripeProduct)
})).addError(InternalServerError).middleware(StripeApiMiddleware).annotate(OpenApi.Summary, "GetAllStripeProducts")).add(HttpApiEndpoint.get("getPricesForProduct")`/applications/${ApplicationId}/stripe/${StripeEnvironmentParam}/products/${StripeProductIdParam}/prices`.addSuccess(Schema.Struct({
    object: Schema.Literal("list"),
    data: Schema.Array(StripePrice)
})).addError(InternalServerError).middleware(StripeApiMiddleware).annotate(OpenApi.Summary, "GetStripePricesForProduct")).add(HttpApiEndpoint.get("getStripeConfigurationStatus")`/applications/${ApplicationId}/stripe/${StripeEnvironmentParam}/configuration-status`.addSuccess(Schema.Struct({
    valid: Schema.Boolean,
    publishableKey: Schema.Boolean,
    secretKey: Schema.Boolean
})).addError(InternalServerError).middleware(StripeControllerMiddleware).annotate(OpenApi.Summary, "GetStripeConfigurationStatus")).add(HttpApiEndpoint.post("ensureWebhookExists")`/applications/${ApplicationId}/stripe/${StripeEnvironmentParam}/webhook/ensure`.addSuccess(Schema.Struct({
    status: Schema.Literal("success")
})).addError(InternalServerError).middleware(StripeControllerMiddleware).annotate(OpenApi.Summary, "EnsureWebhookExists")).add(HttpApiEndpoint.put("updatePublishableKey")`/applications/${ApplicationId}/stripe/${StripeEnvironmentParam}/keys`.setPayload(Schema.Struct({
    publishableKey: Keys.PublishableKey.pipe(Schema.optional),
    secretKey: Keys.SecretKey.pipe(Schema.optional)
})).addError(InternalServerError).addSuccess(Schema.Union(Schema.Struct({
    valid: Schema.Literal(true)
}), Schema.Struct({
    valid: Schema.Literal(false),
    error: Schema.Struct({
        message: Schema.String,
        tag: Schema.String
    })
}))).middleware(StripeControllerMiddleware).annotate(OpenApi.Summary, "UpdatePublishableKey"));
// .add(
//   HttpApiEndpoint.post(
//     "validatePublishableKey"
//   )`/applications/${ApplicationId}/env/${StripeEnvironmentParam}/keys/publishable-key/validate`
//     .setPayload(
//       Schema.Struct({
//         publishableKey: Keys.PublishableKeySealed.pipe(Schema.optional),
//       })
//     )
//     .addSuccess(
//       Schema.Union(
//         Schema.Struct({
//           publishableKey: Schema.Struct({
//             valid: Schema.Literal(true),
//           }),
//         }),
//         Schema.Struct({
//           valid: Schema.Literal(false),
//           error: Schema.Struct({
//             message: Schema.String,
//             statusCode: Schema.Number.pipe(Schema.optional),
//           }),
//         })
//       )
//     )
// )
const FullApi = HttpApi.make("test-api").add(StripeApi);
